import KatalLogger, { Level } from '@amzn/katal-logger';
import { loggerEndpoint, STAGE, stage } from 'src/config';
import { v4 as uuidv4 } from 'uuid';
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Get the logger session ID and create it if necessary.
 * This can be used to collate logs and insights across a users entire session.
 *
 * @returns string
 */

export const getSessionID = () => {
	// If the session has already got an ID
	if (window.sessionStorage.getItem('LoggerSessionID')) {
		// Fetch and return the MetricsSessionID
		return window.sessionStorage.getItem('LoggerSessionID');
	} else {
		// Generate a random session ID for the metrics/logging then store it for later reuse and return it
		const metricsSessionID = uuidv4().replace(/-/g, '');

		window.sessionStorage.setItem('LoggerSessionID', metricsSessionID);

		return metricsSessionID;
	}
};

const katalLoggerConfig = {
	url: loggerEndpoint,
	logThreshold: Level.INFO,
	maxLogLineSize: 10000,
	// The logToConsole config property, if set to true, will cause your errors to log to the javascript console.
	logToConsole: stage == STAGE.DEV,
	context: {
		// Session ID to link events from a single browser session together
		session_id: getSessionID(),
	},
};

const logger = new KatalLogger(katalLoggerConfig);

logger.addErrorListener();
logger.addPerformanceListener();

export { logger };
